import React from 'react';
import { ArrowRight, Sun } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Hero = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const scrollToContact = () => {
    const element = document.getElementById('kontakt');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen overflow-hidden pt-20 sm:pt-24 md:pt-32 lg:pt-40">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://customer-assets.emergentagent.com/job_8c2b47f1-6d08-4b4c-9016-67db6d0453b6/artifacts/rvqfi7mc_Un%20omaggi%20e%20di%20una%20casa%20con%20la%20corrente%20moderna.jpeg"
          alt="Modern House"
          className="w-full h-full object-cover"
        />
        
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b sm:bg-gradient-to-r from-slate-900/90 via-slate-900/70 to-slate-900/50"></div>
      </div>

      {/* Content Overlay */}
      <div className="relative z-10 min-h-[calc(100vh-5rem)] sm:min-h-[calc(100vh-6rem)] md:min-h-[calc(100vh-8rem)] lg:min-h-[calc(100vh-10rem)] flex items-center">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 md:py-0">
          <div className="max-w-3xl">
            {/* Badge */}
            <div className="inline-flex items-center px-3 py-2 bg-white/10 backdrop-blur-md text-white rounded-full text-sm sm:text-sm font-medium mb-5 sm:mb-6 border border-white/20">
              <Sun className="w-4 h-4 sm:w-4 sm:h-4 mr-2 text-amber-400" />
              <span>{t('expertenBadge')}</span>
            </div>
            
            {/* Main Heading */}
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-4 sm:mb-5 md:mb-6 leading-tight">
              {t('heroTitle1')}{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-amber-400">
                {t('heroTitle2')}
              </span>
            </h1>
            
            {/* Description */}
            <p className="text-base sm:text-lg md:text-xl lg:text-xl text-gray-200 mb-6 sm:mb-7 md:mb-8 leading-relaxed max-w-2xl">
              {t('heroDescription')}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 mb-8 sm:mb-10 md:mb-12">
              <Button 
                onClick={() => navigate('/beratung')}
                size="lg"
                className="bg-sky-600 hover:bg-sky-700 text-white px-6 py-4 sm:px-7 sm:py-5 md:px-8 md:py-6 text-base sm:text-lg md:text-lg group shadow-xl w-full sm:w-auto"
              >
                {t('kostenloseBeratung')}
                <ArrowRight className="ml-2 w-5 h-5 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button 
                onClick={() => document.getElementById('produkte').scrollIntoView({ behavior: 'smooth' })}
                size="lg"
                variant="outline"
                className="border-2 border-white/80 text-white hover:bg-white/10 backdrop-blur-sm px-6 py-4 sm:px-7 sm:py-5 md:px-8 md:py-6 text-base sm:text-lg md:text-lg w-full sm:w-auto"
              >
                {t('produkteEntdecken')}
              </Button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 sm:gap-6 md:gap-8 pt-5 sm:pt-6 md:pt-8 border-t border-white/20">
              <div className="text-center sm:text-left">
                <div className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl font-bold text-white mb-1">2500+</div>
                <div className="text-xs sm:text-sm md:text-sm text-gray-300">{t('installationen')}</div>
              </div>
              <div className="text-center sm:text-left">
                <div className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl font-bold text-white mb-1">25+</div>
                <div className="text-xs sm:text-sm md:text-sm text-gray-300">{t('jahreErfahrung')}</div>
              </div>
              <div className="text-center sm:text-left">
                <div className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl font-bold text-white mb-1">98%</div>
                <div className="text-xs sm:text-sm md:text-sm text-gray-300">{t('zufriedenheit')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/70 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;